import { render, staticRenderFns } from "./AssetSearch.vue?vue&type=template&id=5f1bf668&scoped=true&lang=pug&"
import script from "./AssetSearch.vue?vue&type=script&lang=js&"
export * from "./AssetSearch.vue?vue&type=script&lang=js&"
import style0 from "./AssetSearch.vue?vue&type=style&index=0&id=5f1bf668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1bf668",
  null
  
)

export default component.exports